import type { SVGProps } from 'react';

const SvgConfirmedFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <circle cx={12} cy={12} r={10} fill='#26BB7D' />
    <path
      d='M8 11.7273L10.9283 15L16 9'
      stroke='currentColor'
      strokeWidth={1.8}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgConfirmedFilled;
